export default __webpack_public_path__ + "static/media/cloud.9019ff04.svg";